module.exports = __webpack_public_path__ + "static/media/arrow-down3.96cbde59.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/arrow-down3.svg
// module id = 2300
// module chunks = 7